import React, { Component } from 'react';
import './A6.css';

class A6 extends Component{
    render(){
        return(    
        <div className="campoA6">{this.props.children}
        </div>
        )
    }

}

export default A6;